var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_386_32534)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_386_32534",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 0H0V26H26V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_386_32534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7292 22.7497H6.22921V24.3747H12.7292V22.7497ZM2.70837 19.2288V12.7288H1.08337V19.2288H2.70837ZM6.22921 22.7497C5.29542 22.7497 4.39989 22.3787 3.7396 21.7184C3.07932 21.0582 2.70837 20.1626 2.70837 19.2288H1.08337C1.08337 20.5936 1.62552 21.9025 2.59055 22.8675C3.55558 23.8325 4.86445 24.3747 6.22921 24.3747V22.7497ZM16.25 19.2288C16.25 20.1626 15.8791 21.0582 15.2188 21.7184C14.5585 22.3787 13.663 22.7497 12.7292 22.7497V24.3747C14.094 24.3747 15.4028 23.8325 16.3679 22.8675C17.3329 21.9025 17.875 20.5936 17.875 19.2288H16.25ZM12.7292 9.20801C13.663 9.20801 14.5585 9.57895 15.2188 10.2392C15.8791 10.8995 16.25 11.7951 16.25 12.7288H17.875C17.875 11.3641 17.3329 10.0552 16.3679 9.09019C15.4028 8.12516 14.094 7.58301 12.7292 7.58301V9.20801ZM6.22921 7.58301C4.86445 7.58301 3.55558 8.12516 2.59055 9.09019C1.62552 10.0552 1.08337 11.3641 1.08337 12.7288H2.70837C2.70837 11.7951 3.07932 10.8995 3.7396 10.2392C4.39989 9.57895 5.29542 9.20801 6.22921 9.20801V7.58301ZM12.7292 2.70801H19.2292V1.08301H12.7292V2.70801ZM22.75 6.22884V12.7288H24.375V6.22884H22.75ZM22.75 12.7288C22.75 13.6626 22.3791 14.5582 21.7188 15.2184C21.0585 15.8787 20.163 16.2497 19.2292 16.2497V17.8747C20.594 17.8747 21.9028 17.3325 22.8679 16.3675C23.8329 15.4025 24.375 14.0936 24.375 12.7288H22.75ZM19.2292 2.70801C20.163 2.70801 21.0585 3.07895 21.7188 3.73924C22.3791 4.39952 22.75 5.29506 22.75 6.22884H24.375C24.375 4.86408 23.8329 3.55522 22.8679 2.59019C21.9028 1.62516 20.594 1.08301 19.2292 1.08301V2.70801ZM12.7292 1.08301C11.3644 1.08301 10.0556 1.62516 9.09055 2.59019C8.12552 3.55522 7.58337 4.86408 7.58337 6.22884H9.20837C9.20837 5.29506 9.57932 4.39952 10.2396 3.73924C10.8999 3.07895 11.7954 2.70801 12.7292 2.70801V1.08301ZM9.20837 8.39551V6.22884H7.58337V8.39551H9.20837ZM6.22921 9.20801H8.39587V7.58301H6.22921V9.20801ZM8.39587 9.20801H12.7292V7.58301H8.39587V9.20801ZM19.2292 16.2497H17.0625V17.8747H19.2292V16.2497ZM16.25 12.7288V17.0622H17.875V12.7288H16.25ZM16.25 17.0622V19.2288H17.875V17.0622H16.25Z",
    fill: "#333333"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_32534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloneIcon);
export default __webpack_public_path__ + "static/media/clone-icon.6e9f1df3c76a5d609dca591c11362897.svg";
export { ForwardRef as ReactComponent };